export const CancelReasonType = [
  { id: 0, reasonType: "PLANES_CHANGED", reasonName: "Plans have changed"},
  { id: 1, reasonType: "DRIVER_ASKED", reasonName: "Driver asked"},
  { id: 2, reasonType: "WRONG_CAR", reasonName: "The wrong vehicle arrived"},
  { id: 3, reasonType: "LOW_RATING", reasonName: "Low rating"},
  { id: 4, reasonType: "INAPPROPRIATE_BEHAVIOUR", reasonName: "Driver’s inappropriate behavior"},
  { id: 5, reasonType: "AUTO_WAS_LATE", reasonName: "Vehicle was late"},
  { id: 6, reasonType: "DIRTY_CAR", reasonName: "Dirty car"},
];

